import React from "react";
import "./MobileCasinoProviders.css";

const PROVIDERS = [
  "17627670321128629.webp",
  "17627670394952739.webp",
  "17627670461429100.webp",
  "17889579179160978.png",
  "17627670585808315.webp",
  "17627670659323746.webp",
  "17627670718442303.webp",
  "17627670774655812.webp",
  "17838974711553317.png",
  "17627670914326964.webp",
  "17627671036352194.webp",
  "17838974792520238.png",
  "17627671249048208.webp",
  "17840351515120102.png",
  "17816910456586236.png",
  "17627674617189985.webp",
  "17627671431487612.webp",
  "17627671491957490.webp",
];

const MobileCasinoProviders = () => {
  return (
    <section className="mobile-casino-providers" aria-label="Casino providers">
      <h2 className="mobile-casino-providers-title">
        <img
              src={`${process.env.PUBLIC_URL}/Images/play-cart.png`}
              alt=""
            />
        Casino Provider
      </h2>

      <div className="mobile-casino-providers-grid">
        {PROVIDERS.map((imageName) => (
          <button
            key={imageName}
            type="button"
            className="mobile-casino-provider-card"
          >
            <img
              src={`${process.env.PUBLIC_URL}/Images/right-sidebar/${imageName}`}
              alt=""
              loading="lazy"
            />
          </button>
        ))}
      </div>
    </section>
  );
};

export default MobileCasinoProviders;
